import moment from "moment";
import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentMobile, getCurrentUserId } from "@/utils";
// 基本信息
export class OrderInfoReq {
  freight: number = 0; // 运费
  invoiceType: string | undefined = undefined; // 发票类型
  invoiceTypeName: string | undefined = undefined; // 发票类型
  taxRate: string | undefined = undefined; // 税率
  name: string = `采购订单${moment().format("YYYYMMDDHHmmss")}`; // 采购订单名称
  orderDate: string = moment().format("YYYY-MM-DD"); // 订单日期
  projectId: string | undefined = undefined; // 项目 ID
  purchaseContractId: string | undefined = undefined; // 采购合同 ID
  purchaseTenantUserId: string | undefined = getCurrentUserId(); // 采购员 ID
  supplierId: string | undefined = undefined; // 供应商 ID
  partyBCooperationCompanyName: string | undefined = undefined; // 供应商名称
  receiveProvinceId: number = 0; // 收货省 ID
  receiveCityId: number = 0; // 收货市 ID
  receiveDistrictId: number = 0; // 收货区 ID
  receiveAddress: string = ""; // 收货详细地址
  receiveTenantUserId: string = getCurrentUserId(); // 收货人 ID
  receiveTenantUserMobile: string = getCurrentMobile(); // 收货人联系方式
  supplierContacts: string = ""; // 供应商联系人
  supplierMobile: string = ""; // 供应商联系电话
  taxPriceSum: number = 0; // 采购金额
  remark: string = ""; // 摘要
}

// 采购明细
export class MaterialRecord extends BaseReq {
  systemName: string = ""; // 系统名称
  uuid: string = ""; // 唯一ID
  bizNo: string = ""; // 清单编号
  purchaseContractDetailId: string = ""; //
  materialId: string = ""; // 材料 ID
  materialNo: string = ""; // 材料编号
  materialName: string = ""; // 材料名称
  materialModel: string = ""; // 规格型号
  materialBrand: string = ""; // 品牌
  materialUnit: string = ""; // 结算单位
  contractCount: number = 0; // 采购合同数量
  currentOrderCount: number = 0; // 本次订单数量
  taxPrice: number = 0; // 单价-含税
  price: number = 0; // 单价-不含税
  taxTotalPrice: number = 0; // 金额-含税
  totalPrice: number = 0; // 金额-不含税
  taxRate: string = ""; // 税率
  taxAmount: number = 0; // 税额
  deliveryDay: number = 0; // 要求交货周期
  aogDay: string = ""; // 计划到货日期
  remark: string = ""; // 备注
  id: string = "";
  cumulativeSignCount: number = 0; // 累计已签数量
  source: string = "";//来源
  sortFiled: number = 0;
  currentArrivalCount: number;
  materialCategoryId: string = ""; // 材料分类 ID
  materialCategoryName: string = ""; // 材料分类名称
}

export class OrderReq extends BaseReq {
  purchaseOrderInfoReq: OrderInfoReq = new OrderInfoReq(); // 基本信息
  purchaseOrderDetailReqs: MaterialRecord[] = []; // 采购明细
  list: MaterialRecord[] = []; // 采购明细
  fileList: FileRecord[] = []; //附件
  id:number=0;//
}

export class OrderPageReq extends PaginationReq {
  bizNo: string | undefined = undefined; // 采购订单编号
  name: string | undefined = undefined; // 采购订单名称
  supplierId: string | undefined = undefined; // 供应商 ID
  supplierName: string | undefined = undefined; // 供应商名称
  filterNumFlag: string = "1";
  orderStartDate: string | undefined = undefined; // 订单开始日期
  orderEndDate: string | undefined = undefined; // 订单结束日期
  purchaseTenantUserId: string | undefined = undefined; // 采购员
  storageStatus: string | undefined = undefined; // 入库状态
  validStatus: string | undefined = undefined; //生效状态
  id:string|undefined=undefined;//id
  purchaseContractId:string|undefined=undefined;//采购合同id
  purchaseContractName:string|undefined=undefined;//采购合同名称
  projectId:string|undefined=undefined;//项目id
  addRightBizType:string|undefined=undefined;
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class OrderListRecord extends UpdaterResp {
  id: number = 0; // 采购订单ID
  bidNo: string = ""; // 采购订单编号
  name: string = ""; // 采购订单名称
  partyBCooperationCompanyName: string = ""; // 乙方-供应商名称
  orderTime: string = ""; // 申请日期
  purchaseTenantUserId: string = ""; // 采购员 ID
  purchaseTenantUserName: string = ""; // 采购员名称
  orderDate: string = ""; // 订单日期
  receiveTenantUserId: string = ""; // 收货人 ID
  receiveTenantUserName: string = ""; // 收货人名称
  taxPriceSum: number = 0; // 采购金额
  storageStatus: string = ""; // 入库状态
  storageStatusName: string = ""; // 入库状态
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
}

export class OrderPageResp extends PaginationResp<OrderListRecord> {}

export class OrderSimpleRecord {
  id: string; // 采购订单 ID
  bizNo: string = ""; // 采购订单编号
  name: string = ""; // 采购订单名称
  projectId: string = ""; // 项目 ID
}

class DetailResp extends UpdaterResp {
  freight: number = 0; // 运费
  invoiceType: string = ""; // 发票类型
  invoiceTypeName: string = ""; // 发票类型
  taxRate: string = ""; // 税率
  taxRateName: string = ""; // 税率
  name: string = ""; // 采购订单名称
  orderDate: string = ""; // 订单日期
  projectId: string = ""; // 项目 ID
  projectName: string = ""; // 项目名称
  purchaseContractId: string = ""; // 采购合同 ID
  purchaseContractName: string = ""; // 采购合同名称
  purchaseTenantUserId: string = ""; // 采购员 ID
  purchaseTenantUserName: string = ""; // 采购员名称
  supplierId: string = ""; // 供应商 ID
  partyBCooperationCompanyName: string = ""; // 供应商名称
  receiveProvinceId: number = 0; // 收货省 ID
  receiveCityId: number = 0; // 收货市 ID
  receiveDistrictId: number = 0; // 收货区 ID
  receiveAddress: string = ""; // 收货详细地址
  receiveTenantUserId: string = ""; // 收货人 ID
  receiveTenantUserMobile: string = ""; // 收货人联系方式
  supplierContacts: string = ""; // 供应商联系人
  supplierMobile: string = ""; // 供应商联系电话
  taxPriceSum: number = 0; // 采购金额
  remark: string = ""; // 摘要
  validStatus: string = ""; // 生效状态
  validStatusName: string = ""; // 生效状态
  flowStatus: string = ""; // 审批状态Code
  flowStatusName: string = ""; // 审批状态名称
  id: string = "";
}

export class OrderDetailResp {
  purchaseOrderAResp: DetailResp = new DetailResp();
  purchaseOrderDetailAResps: MaterialRecord[] = [];
  name: string = "";
}

export class MaterialPageReq extends PaginationReq {
  id: string = ""; // 采购订单 ID
  materialName: string = ""; // 材料名称

  constructor(id) {
    super();
    this.id = id;
  }
}

export class MaterialPageResp extends PaginationResp<MaterialRecord> {}
